export const SUPPORTED_LANGUAGES = [
  'en',
  'nl',
  'fr',
  'it',
  'pl',
  'sk',
  'es',
  'uk',
  'de',
  'pt',
  'sv',
  'ro',
  'cs',
  'hu',
  'el',
  'da',
  'fi',
  'bg',
  'hr',
  'lt',
  'et',
  'lv',
  'sl',
  'no',
  'lb',
  'tr',
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const FALLBACK_LANGUAGE = 'en';

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_FLAGS: Record<string, string> = {
  en: '\u{1F1EC}\u{1F1E7}',
  nl: '\u{1F1F3}\u{1F1F1}',
  fr: '\u{1F1EB}\u{1F1F7}',
  it: '\u{1F1EE}\u{1F1F9}',
  pl: '\u{1F1F5}\u{1F1F1}',
  sk: '\u{1F1F8}\u{1F1F0}',
  es: '\u{1F1EA}\u{1F1F8}',
  uk: '\u{1F1FA}\u{1F1E6}',
  de: '\u{1F1E9}\u{1F1EA}',
  pt: '\u{1F1F5}\u{1F1F9}',
  sv: '\u{1F1F8}\u{1F1EA}',
  ro: '\u{1F1F7}\u{1F1F4}',
  cs: '\u{1F1E8}\u{1F1FF}',
  hu: '\u{1F1ED}\u{1F1FA}',
  el: '\u{1F1EC}\u{1F1F7}',
  da: '\u{1F1E9}\u{1F1F0}',
  fi: '\u{1F1EB}\u{1F1EE}',
  bg: '\u{1F1E7}\u{1F1EC}',
  hr: '\u{1F1ED}\u{1F1F7}',
  lt: '\u{1F1F1}\u{1F1F9}',
  et: '\u{1F1EA}\u{1F1EA}',
  lv: '\u{1F1F1}\u{1F1FB}',
  sl: '\u{1F1F8}\u{1F1EE}',
  no: '\u{1F1F3}\u{1F1F4}',
  lb: '\u{1F1F1}\u{1F1FA}',
  tr: '\u{1F1F9}\u{1F1F7}',
};

export interface LanguageOption {
  readonly key: string;
  readonly name: string;
  readonly flag: string;
  readonly isActive?: boolean;
}
